var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bld-cat-pick-btn-main"},[_c('div',{staticClass:"title wi8_font"},[_vm._v("Category Picker Button Builder (cat: "+_vm._s(_vm.current.title)+")")]),_c('CatPickBtn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }